"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMessage = exports["default"] = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var getErrorPath = function getErrorPath(errors) {
  var flattened = (0, _utils.flattenObject)(errors);
  var formulaErrorPath = '';
  R.forEach(function (item) {
    if (item.indexOf('generic') !== -1 && !R.isEmpty(flattened[item])) {
      formulaErrorPath = item.split('.');
    }
  }, R.keys(flattened));
  return formulaErrorPath;
};
var getErrorMessage = exports.getErrorMessage = function getErrorMessage(errors) {
  var errorPath = getErrorPath(errors);
  return (0, _utils.isBlank)(errorPath) ? errorPath : R.path(errorPath, errors);
};
var _default = exports["default"] = getErrorMessage;